import { rem } from "polished";
import styled from "styled-components";

import { ColorLabels } from "@/components/editor/utils/use-color";

export const Card = styled.div`
  display: inline-block;
  width: 100%;
  max-width: ${rem(288)};
  margin: 0 ${rem(11)} ${rem(32)} ${rem(11)};
  box-sizing: content-box;
  background: ${({ theme }) => theme.colors[ColorLabels.VISUALS]};

  .text-primitive {
    text-align: center;
  }
`;

export const Content = styled.div`
  display: grid;
  justify-items: center;
  gap: ${rem(4)};
  padding: ${rem(40)} ${rem(24)};
`;

export const Media = styled.img`
  display: block;
  height: ${rem(152)};
  width: ${rem(152)};
  object-fit: cover;
  border-radius: 100%;
`;

export const StyledName = styled.div`
  display: flex;
  margin-top: ${rem(24)};

  .text-primitive {
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const StyledHeadline = styled.div`
  display: flex;
  margin-bottom: ${rem(48)};

  .text-primitive {
    color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  }
`;

export const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${rem(20)};
`;
